<div class="notification-bell-wrapper position-relative">
  <button
    class="btn btn-link notification-bell-btn p-0"
    (click)="toggleDropdown()"
    aria-label="Notificações"
  >
    <i class="fa-solid fa-bell"></i>
    <span *ngIf="unreadCount > 0" class="notification-badge">{{
      unreadCount > 99 ? "99+" : unreadCount
    }}</span>
  </button>

  <div class="notification-dropdown card shadow" *ngIf="showDropdown">
    <!-- Cabeçalho -->
    <div
      class="notification-dropdown-header d-flex justify-content-between align-items-center px-3 py-2"
    >
      <span class="fw-semibold">Notificações</span>
      <button
        *ngIf="activeTab === 'all' && unreadCount > 0"
        class="btn btn-link btn-sm p-0 text-muted"
        (click)="markAllAsRead()"
        title="Marcar todas como lidas"
      >
        Marcar todas como lidas
      </button>
    </div>

    <!-- Abas -->
    <div class="notification-tabs d-flex">
      <button
        class="notification-tab flex-fill"
        [class.active]="activeTab === 'all'"
        (click)="switchTab('all')"
      >
        Todas
      </button>
      <button
        class="notification-tab flex-fill"
        [class.active]="activeTab === 'archived'"
        (click)="switchTab('archived')"
      >
        Arquivadas
      </button>
    </div>

    <!-- Conteúdo -->
    <div class="notification-dropdown-body">
      <ng-container *ngIf="visibleNotifications.length > 0; else emptyState">
        <button
          *ngFor="let n of visibleNotifications"
          class="notification-item px-3 py-2 w-100 text-start border-0 bg-transparent"
          [class.unread]="!n.read"
          [class.clickable]="!!n.link"
          (click)="onNotificationClick(n)"
        >
          <div class="d-flex align-items-start gap-2">
            <i class="{{ iconClass(n.type) }} mt-1 flex-shrink-0"></i>
            <div class="flex-grow-1 overflow-hidden">
              <div class="d-flex justify-content-between align-items-start">
                <div class="notification-title fw-semibold text-truncate">
                  {{ n.title }}
                </div>
                <button
                  *ngIf="activeTab === 'all'"
                  class="btn btn-link btn-sm p-0 ms-2 text-muted flex-shrink-0 notification-archive-btn"
                  title="Arquivar"
                  (click)="archiveNotification($event, n)"
                >
                  <i
                    class="fa-solid fa-box-archive"
                    style="font-size: 0.75rem"
                  ></i>
                </button>
              </div>
              <div class="notification-message text-muted small">
                {{ n.message }}
              </div>
              <div
                class="notification-time text-muted"
                style="font-size: 0.7rem"
              >
                {{ n.createdAt | date: "dd/MM/yyyy HH:mm" }}
              </div>
            </div>
          </div>
        </button>
      </ng-container>

      <ng-template #emptyState>
        <div class="notification-empty text-center text-muted py-4 px-3">
          <span>{{
            activeTab === "archived"
              ? "Nenhuma notificação arquivada"
              : "Nenhuma notificação no momento"
          }}</span>
        </div>
      </ng-template>
    </div>
  </div>
</div>
